import ContactInfo from './ContactInfo';
import Skill from './Skill';
import Task from './Task';

export default class Employee {
  public firstName: string = '';
  public lastName: string = '';
  public description: string = '';
  public skills: Skill[] = [];
  public assignedTasks: Task[] = [];
  public completedTaskCount: number = 0;
  public availableTimeSlots = {};
  public rating: number = 0;
  public photo: string = '';
  public ktp: string = '';
  public email: string;
  public userEmail: string;
  public contactInfo: ContactInfo;

  get fullName(): string {
    return `${this.firstName} ${this.lastName}`;
  }
}
